export const LoadingSpinner = () => {
  return (
    <div className="animate-spin rounded-full h-12 w-12 border-4 border-brand-teal border-t-transparent" />
  );
};
